<template>
  <QDialog
    ref="dialog"
    @hide="onDialogHide"
    transition-show="slide-up"
    transition-hide="slide-down"
    maximized
    :no-route-dismiss="noRouteDismiss"
  >
    <QCard class="column">
      <div
        class="row full-width justify-end q-pr-md q-pt-md"
        v-if="displayHideAction"
      >
        <SAIIconBtn @click="hide" color="grey-6" />
      </div>
      <component
        v-if="child"
        :is="child"
        v-bind="childProps"
        @close="hide"
        class="col scroll relative"
      />
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard } from 'quasar';

export default {
  name: 'SAIFullScreenDialog',
  props: {
    child: undefined,
    childProps: {
      type: Object,
      default: () => ({})
    },
    displayHideAction: Boolean,
    noRouteDismiss: Boolean
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide() {
      this.$emit('hide');
    }
  },
  components: {
    QDialog,
    QCard,
    SAIIconBtn: () => import('../../atom/sai-icon-btn')
  }
};
</script>
